module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v(_vm._s(_vm.parsedDate))])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-72ebb27c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/general/Date.vue
 ** module id = 858
 ** module chunks = 1
 **/